import CustomCard from '@/components/customCard';
import RegularText from '@/components/RegularText';
import React from 'react';
import { ButtonIconVerticalStyled } from './styled';
import { Tooltip } from '@shopify/polaris';

interface IProps {
  icon?: React.ReactElement;
  title?: string;
  onClick?: () => void;
  children?: React.ReactElement | string;
  disabled?: boolean;
  tooltip?: React.ReactNode;
  selected?: boolean;
  fullHeight?: boolean;
  disabledBackgroundColor?: string;
}

const ButtonIconVertical = (props: IProps) => {
  const content = (
    <CustomCard
      style={{ height: '100%' }}
      cardClassName="h-full"
      title={
        <div>
          <div className="card-icon">{props.icon}</div>
          <div className="mt-8">{props.title}</div>
        </div>
      }
    >
      <RegularText>{props.children}</RegularText>
    </CustomCard>
  );

  return (
    <ButtonIconVerticalStyled
      className="card-container h-full"
      onClick={props.disabled ? undefined : props.onClick}
      disabled={props.disabled}
      selected={props.selected}
      fullHeight={props.fullHeight}
      disabledBackgroundColor={props.disabledBackgroundColor}
    >
      {props.tooltip ? <Tooltip content={props.tooltip}>{content}</Tooltip> : content}
    </ButtonIconVerticalStyled>
  );
};

export default ButtonIconVertical;
